import { ConfirmIdentity } from '../StepperContent/ConfirmIdentity';
import { EnterOldAndNewPassword } from '../StepperContent/EnterOldAndNewPassword';

export const ContentData = {
  1: { content: <EnterOldAndNewPassword /> },
  2: { content: <ConfirmIdentity /> },
};
